import { Box, Stack } from '@mui/material'
import { ICheckupList, PositionHoof } from 'models'
import { Dispatch, SetStateAction } from 'react'
import { COLORS } from 'styles/colors'
import { hoofLabels } from 'ui/HoofPicker/helpers/getLabel'
import { TypographyHeaderSecondary } from 'ui/typography/TypographyHeaderSecondary'
import { TypographyPrimary16Bold } from 'ui/typography/TypographyPrimary16Bold'
import { TypographySecondary } from 'ui/typography/TypographySecondary'
import {
	DiagnosisSelectSection,
	HoofPickerSection,
	TreatmentSchemsBlock,
} from './blocks'

interface TreatmentSectionProps {
	setCheckupInfo: Dispatch<SetStateAction<ICheckupList>>
	checkupInfo: ICheckupList
	isSubmitAttempted?: boolean
	hasCompleteDiagnosis?: boolean
	selectedHoof: PositionHoof | null
	setSelectedHoof: Dispatch<SetStateAction<PositionHoof | null>>
}

export const TreatmentSection = ({
	setCheckupInfo,
	checkupInfo,
	isSubmitAttempted,
	hasCompleteDiagnosis,
	selectedHoof,
	setSelectedHoof,
}: TreatmentSectionProps) => {
	return (
		<Stack direction='column' gap='24px' width='100%'>
			<TypographyHeaderSecondary>Лечение</TypographyHeaderSecondary>
			<Box
				display='flex'
				flexDirection='row'
				width='100%'
				alignItems='flex-start'
				gap='80px'
			>
				<HoofPickerSection
					selectedHoof={selectedHoof}
					setSelectedHoof={setSelectedHoof}
					diagnosis={checkupInfo.diagnosis}
					isSubmitAttempted={Boolean(isSubmitAttempted)}
					hasCompleteDiagnosis={Boolean(hasCompleteDiagnosis)}
				/>
				<Stack
					direction='column'
					gap='16px'
					width='432px'
					maxWidth='100%'
					minWidth={0}
				>
					<TypographyPrimary16Bold
						sx={{
							color: selectedHoof ? COLORS.black : COLORS.inputBorder,
						}}
					>
						Диагноз и схема лечения
						{selectedHoof ? `: ${hoofLabels[selectedHoof].toLowerCase()}` : ''}
					</TypographyPrimary16Bold>
					{selectedHoof ? (
						<>
							<DiagnosisSelectSection
								selectedHoof={selectedHoof}
								setCheckupInfo={setCheckupInfo}
								checkupInfo={checkupInfo}
								isSubmitAttempted={Boolean(isSubmitAttempted)}
							/>
							<TreatmentSchemsBlock
								selectedHoof={selectedHoof}
								setCheckupInfo={setCheckupInfo}
								checkupInfo={checkupInfo}
								isSubmitAttempted={Boolean(isSubmitAttempted)}
							/>
						</>
					) : (
						<TypographySecondary>
							Выберите копыто, чтобы указать диагноз и схему лечения
						</TypographySecondary>
					)}
				</Stack>
			</Box>
		</Stack>
	)
}
